import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';

export const CatalogPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader hasLeftIcon />
      <TableLoader hideFilters hideActions columnsCount={3} />
    </div>
  );
};
